/**
 * ChordWizardWrapper Component
 * Wrapper for Chord Wizard modal
 */

import React from 'react';
import { ChordWizard } from '../chordwizard';

export const ChordWizardWrapper = ({
  isOpen,
  onClose,
  onInsertToTrack,
  onAddToChordTrack,
  audioContextRef,
}) => {
  return (
    <ChordWizard
      isOpen={isOpen}
      onClose={onClose}
      onInsertToTrack={onInsertToTrack}
      onAddToChordTrack={onAddToChordTrack}
      audioContext={audioContextRef?.current}
    />
  );
};

export default ChordWizardWrapper;
